export default __webpack_public_path__ + "static/media/private2.02665e06.PNG";